import React from 'react';
import Loading from '../misc/Loading';
import StatusCode from '../util/StatusCode';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

const SavingState = ({ status }) => {
    const { t } = useTranslation(['common']);

    if (status === StatusCode.PENDING) {
        return (<Loading class="spinnerSmall" />)
    }
    if (status === StatusCode.COMPLETE) {
        return <p><FontAwesomeIcon icon="check-circle" className="saving-icon ok" />{t('savingState.done', { ns: 'common' })}</p>
    }
    if (status === StatusCode.ERROR) {
        return (<p><FontAwesomeIcon icon="xmark-circle" className="saving-icon error" />{t('savingState.error', { ns: 'common' })}</p>);
    }
    return null;
}

export default SavingState;
